module.exports = __webpack_public_path__ + "img/JobFair21_logo1.aa143c39.png";